import { Card, CardContent, CardHeader, Checkbox, makeStyles } from '@material-ui/core';
import React, { useContext, useEffect, useState } from 'react';
import { ConciliacaoContext } from '../ConciliacaoContext';

const useStyles = makeStyles((theme) => ({
  containerExtratoInfo: {
    minHeight: '255px',
    maxHeight: '255px',
  },
}));

const ContainerInformacaoExtrato = ({ children, extrato }) => {
  const classes = useStyles();

  const [checked, setChecked] = useState(extrato?.selected || false);
  const [selecao, setSelecao] = useContext(ConciliacaoContext).selecao;

  const extratoSelected = extrato?.selected;
  useEffect(() => setChecked(extratoSelected || false), [extratoSelected]);

  const handleClick = () => {
    setChecked(!checked);
    extrato.selected = !checked;

    if (containsObject(extrato, selecao) === false) {
      setSelecao((selections) => [...selections, extrato]);
    } else {
      const selecaoFiltrada = selecao.filter((obj) => {
        return obj !== extrato;
      });

      setSelecao(selecaoFiltrada);
    }
  };

  function containsObject(obj, list) {
    let i;

    for (i = 0; i < list.length; i++) {
      if (list[i] === obj) {
        return true;
      }
    }

    return false;
  }

  return (
    <Card variant="outlined">
      <CardHeader
        style={{ padding: '0px' }}
        title={
          <Checkbox
            color="primary"
            name="extrato"
            value={extrato.selected || false}
            checked={checked}
            onClick={handleClick}
          />
        }
      />
      <CardContent className={classes.containerExtratoInfo}>{children}</CardContent>
    </Card>
  );
};

export default ContainerInformacaoExtrato;
